export interface ITrackingState {
    ldActiveExperiments: Record<string, boolean>;
}

export const defaultTrackingState: ITrackingState = {
    ldActiveExperiments: {},
};
